"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitLagunitas = void 0;
//require('select2');
require('slick-carousel');
function InitLagunitas() {
    const isMobileLayout = function () {
        console.log(window.innerWidth);
        return (window.innerWidth < 1400);
    };
    $(() => {
        $('.popUpForm, form').on('click', (e) => {
            const target = $(e.target);
            if (target.is(".popUpForm, form")) {
                $('html').toggleClass('pop');
            }
        });
        // Hide form sent message and show form after submit
        $('body').on('click', (e) => {
            const target = $(e.target);
            if (!target.is('.FormSubmitButton')) {
                $('.Form__MainBody').show();
                $('.Form__Status > div').removeClass('Form__Status__Message').addClass('hide');
            }
        });
        jQuery('.o-video-container > video').click(function () {
            if (jQuery(this).hasClass('play')) {
                $(this).trigger('pause');
                $(this).removeClass('play');
            }
            else {
                $(this).trigger('play');
                jQuery(this).addClass('play');
            }
        });
    });
}
exports.InitLagunitas = InitLagunitas;
